module.exports = __webpack_public_path__ + "media/assets/images/flags/fo-b605a132291ebfb58b791c7a4cee6e39.svg";